// extracted by mini-css-extract-plugin
module.exports = {"placesAutocomplete":"places-autocomplete_placesAutocomplete__EEhts","searchIcon":"places-autocomplete_searchIcon__jFfZT"};